import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { TransitionGroup, Transition } from 'react-transition-group';
import { cond, equals, always } from 'ramda';

import {
  SNACKBAR_NAMES,
  SNACKBAR_LOGOUT_SUCCESS,
  SNACKBAR_ERROR,
  SNACKBAR_TIMEOUT_SNACKBAR,
  SNACKBAR_YOUR_PROFILE_UPDATED,
  SNACKBAR_RESET_PASSWORD_EMAIL_SENT,
  SNACKBAR_CANCEL_BOOKING_SUCCESS,
} from '../../../modules/snackbar/snackbar.constants';
import messages from './snackbar.messages';
import { Success } from './success';
import { renderWhenNotNil } from '../../utils/rendering';
import { TRANSITION_DURATION } from './snackbarRender.styles';
import { Error } from './error';
import { Timeout } from './timeout';

export class SnackbarRender extends PureComponent {
  static propTypes = {
    activeSnackbar: PropTypes.oneOf(SNACKBAR_NAMES),
  };

  renderSnackbar = (name, state) =>
    cond([
      [equals(SNACKBAR_LOGOUT_SUCCESS), always(<Success state={state} message={messages.logoutSuccess} />)],
      [equals(SNACKBAR_ERROR), always(<Error state={state} />)],
      [equals(SNACKBAR_TIMEOUT_SNACKBAR), always(<Timeout state={state} />)],
      [
        equals(SNACKBAR_CANCEL_BOOKING_SUCCESS),
        always(<Success state={state} message={messages.cancelBookingSuccess} />),
      ],
      [
        equals(SNACKBAR_YOUR_PROFILE_UPDATED),
        always(<Success state={state} message={messages.yourProfileDataUpdated} />),
      ],
      [
        equals(SNACKBAR_RESET_PASSWORD_EMAIL_SENT),
        always(<Success state={state} message={messages.resetPasswordEmailSent} />),
      ],
    ])(name);

  render() {
    const { activeSnackbar } = this.props;

    return (
      <TransitionGroup component={null}>
        {renderWhenNotNil(() => (
          <Transition timeout={TRANSITION_DURATION}>
            {state => {
              return this.renderSnackbar(activeSnackbar, state);
            }}
          </Transition>
        ))(activeSnackbar)}
      </TransitionGroup>
    );
  }
}
